import React from 'react'
import { Box, Text, Grid } from '@moonpig/launchpad-components'
import { IconSystemTick, IconSystemCross } from '@moonpig/launchpad-assets'
import { colorValue } from '@moonpig/launchpad-theme'
import { styled } from '@moonpig/launchpad-utils'
import { PasswordRuleItem } from './types'
import { useAuthenticationLocaleText } from '../../text-localisation'

const upperCaseRegEx = /^(?=.*[A-Z])/
const lowerCaseRegEx = /^(?=.*[a-z])/
const numberRegEx = /^(?=.*[0-9])/
const lengthRegEx = /^.{8,74}$/

export const PasswordRules: React.FC<{
  password: string
}> = ({ password }) => {
  const localiseText = useAuthenticationLocaleText()

  const getRules = (): PasswordRuleItem[] => {
    return [
      {
        text: localiseText('auth_wizard.password_rule_length'),
        isValid: lengthRegEx.test(password),
      },
      {
        text: localiseText('auth_wizard.password_rule_number'),
        isValid: numberRegEx.test(password),
      },
      {
        text: localiseText('auth_wizard.password_rule_uppercase'),
        isValid: upperCaseRegEx.test(password),
      },
      {
        text: localiseText('auth_wizard.password_rule_lowercase'),
        isValid: lowerCaseRegEx.test(password),
      },
    ]
  }

  return (
    <Grid>
      {getRules().map(rule => (
        <StyledBox width={0.5} key={rule.text}>
          {rule.isValid ? <SuccessTick /> : <ErrorCross />}
          {rule.isValid ? (
            <SuccessText typography="typeDisplay06">{rule.text}</SuccessText>
          ) : (
            <ErrorText typography="typeDisplay06" color="colorBlack60">
              {rule.text}
            </ErrorText>
          )}
        </StyledBox>
      ))}
    </Grid>
  )
}

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
`

const SuccessTick = styled(IconSystemTick)`
  color: ${colorValue('colorFeedbackSuccess')};
  width: 18px;
  height: 18px;
`

const ErrorCross = styled(IconSystemCross)`
  color: ${colorValue('colorFeedbackError')};
  width: 18px;
  height: 18px;
`
const SuccessText = styled(Text)`
  color: ${colorValue('colorFeedbackSuccess')};
  margin-left: 4px;
  margin-top: 4px;
`

const ErrorText = styled(Text)`
  margin-left: 4px;
  margin-top: 4px;
`
